Pixlee.module('Utilities', function(Utilities, App, Backbone, Marionette, $) {
    _.extend(App, {
        /**
         * A safe method that returns an object with two properties:
         * 
         * 1. `backgroundPosition`, which is a string corresponding to the proper value of the
         * CSS background-position based on the photo's viewport (edited thumbnail) data.
         * 
         * 2. `backgroundSize`, which is a string corresponding to the proper value of the
         * background-size CSS based on the photo's viewport (edited thumbnail) data.
         * 
         * If there is no viewport data, backgroundPosition defaults to 'center center'
         * and backgroundSize defaults to 'cover'.
         * 
         * More details about percentage-based background-position:
         * https://developer.mozilla.org/en-US/docs/Web/CSS/background-position#regarding_percentages
         * 
         * @param {Object} viewport 
         * @param {number} viewport.x - the offset left of the cropped area
         * @param {number} viewport.y - the offset top of the cropped area
         * @param {number} viewport.width - the width of the cropped area
         * @param {number} viewport.height - the height of the cropped area
         * @param {number} viewport.imgWidth - the width of the original image
         * @param {number} viewport.imgHeight - the height of the original image
         * @returns {{backgroundPosition: string, backgroundSize: string}}
         */
        getViewportBackgroundDimensions: function(viewport) {
            var backgroundPosition = 'center center';
            var backgroundSize = 'cover';

            if (_.has(viewport, 'x') && _.has(viewport, 'y') && _.has(viewport, 'width') &&
                _.has(viewport, 'height') && _.has(viewport, 'imgWidth') && _.has(viewport, 'imgHeight')) {

                var imageWidthDifference = (viewport.imgWidth - viewport.width) || 1;
                var imageHeightDifference = (viewport.imgHeight - viewport.height) || 1;

                var backgroundPositionX = viewport.x / imageWidthDifference * 100;
                var backgroundPositionY = viewport.y / imageHeightDifference * 100;

                backgroundPosition = backgroundPositionX.toString() + '% ' + backgroundPositionY.toString() + '%';

                var backgroundSizeWidth = viewport.imgWidth / viewport.width * 100;
                var backgroundSizeHeight = viewport.imgHeight / viewport.height * 100;
                backgroundSize = backgroundSizeWidth.toString() + '% ' + backgroundSizeHeight.toString() + '%';
            }
            return {
                backgroundPosition: backgroundPosition,
                backgroundSize: backgroundSize
            };
        }
    });
});
